<template><!-- 試算頁注意事項共用 -->
    <div id="attention">
        <div>線上投保注意事項 <img class="insure_info_accu" src="../assets/question.svg" alt="" @click="popupAttention"></div>
    </div>
</template>
<script setup>
   import Swal from "sweetalert2";

   const popupAttention = ()=>{
       var alertCon =
           '<div class="noticeCon attention">' +
           '<ol>' +
           '<li>要保人需為年滿18歲以上自然人。</li>' +
           '<li>投保時，要保人與被保險人均須在台、澎、金、馬境內。</li>' +
           '<li>身故受益人僅限配偶、直系血親(如父母、子女、祖父母)或法定繼承人。</li>' +
           '<li>依保險法規範，未滿15歲被保險人其喪葬費用保險金給付總和不得超過投保時遺產與贈與稅法第17條有關遺產稅喪葬費扣除額之半數，目前限額為69萬 ∘</li>' +
           '<li>因應主管機關規範，同一被保險人以網路投保旅平險並附加實支實付傷害醫療保險，重疊保險期間限投保1張。</li>' +
           '<li>同一保險期間（或保期有重疊），於本公司投保旅行綜合保險次數限1次。</li>' +
           '<li>保單型式：僅提供電子保單。</li>' +
           '<li>繳費須使用會員(要保人)之本人信用卡線上刷卡。(下列機構發行之信用卡不適用：澳盛銀行)</li>' +
           '<li>國外旅平險投保海外突發疾病險，須同時加購旅遊不便險，並依方案符合以下條件：</li>' +
           '<ul><li>不包含法定傳染病：被保險人未滿70歲、保險期間30天內(含)、出發日距離投保日30天內(含)。</li>' +
           '<li>包含法定傳染病：被保險人年滿15歲至未滿70歲、保險期間30天內(含)、出發日距離投保日30天內(含)、旅遊國家為非申根國。</li></ul>' +
           '<li>國外旅平險欲申請申根憑證，旅遊國家請選擇申根國，且投保身故及失能1,200萬、傷害醫療120萬、海外突發疾病險150萬<span class="pinkText">(不包含法定傳染病)</span>、緊急救援費用保險150萬。投保成功後將收到電子保單及申根憑證。</li>' +
           '</ol>' +
           '<h3 class="blueTitle">網路投保</h3>' +
           '<ul class="caption">' +
           '<li class="captionTitle"><p>投保年齡(以旅遊出發時間為基準)</p><p>旅平險最高投保金額</p></li>' +
           '<li><p>未滿7歲</p><p>69萬元</p></li>' +
           '<li><p>滿7歲至未滿15歲</p><p>-</p></li>' +
           '<li><p>滿15歲至未滿18歲</p><p>-</p></li>' +
           '<li><p>滿18歲至未滿70歲</p><p>國內500萬元 / 國外1,200萬元</p></li>' +
           '<li><p>滿70歲至未滿80歲</p><p>300萬元</p></li>' +
           '<li><p>投保身份與人數</p><p>限本人或幫未滿7歲子女投保(最多四位)</p></li>' +
           '<li><p>投保時間</p><p>最晚須於出發時間1小時前完成投保</p></li>' +
           '<li><p>保單成立</p><p>線上完成繳費即成立保單</p></li>' +
           '</ul>' +
           '<h3 class="blueTitle">網路要保(回傳要保書)</h3>' +
           '<ul class="caption">' +
           '<li class="captionTitle"><p>投保年齡(以旅遊出發時間為基準)</p><p>旅平險最高投保金額</p></li>' +
           '<li><p>未滿7歲</p><p>69萬元</p></li>' +
           '<li><p>滿7歲至未滿15歲</p><p>69萬元</p></li>' +
           '<li><p>滿15歲至未滿18歲</p><p>國內500萬元 / 國外1,500萬元</p></li>' +
           '<li><p>滿18歲至未滿70歲</p><p>國內500萬元 / 國外1,500萬元</p></li>' +
           '<li><p>滿70歲至未滿80歲</p><p>300萬元</p></li>' +
           '<li><p>投保身份與人數</p><p>可為本人與家人們投保(最多四位)</p></li>' +
           '<li><p>投保時間</p><p>最晚須於出發日前3個工作日完成投保</p></li>' +
           '<li><p>保單成立</p><p>須於時效內簽名回傳要保書，並在通過審核後才算正式成立</p></li>' +
           '</ul>' +
           '<div class="attentionTxt pinkText">' +
           '<img class="attention" src="noticemark.svg">' +
           '<span>提醒您，欲投保的身份、年齡或投保額度需求不在上表中，請致電網路投保客服專線0800-366-168，或0800-050-119洽詢。</span>' +
           '</div>' +
           '</div>'
       Swal.fire({
           title: "旅平險線上投保前注意事項",
           showConfirmButton: false,
           showCloseButton: true,
           customClass: {
               container: "attentionAlert",
           },
           html: alertCon
       });
   }

</script>
<style lang="scss">
#attention{
    width:100%;
    text-align: center;
    color:#fff;
    padding:0 35px;
    box-sizing: border-box;
    font-weight:700;
    background:$blue-700;
    line-height:50px;
    border-radius: 30px;
    img {
        display: block;
        float: right;
        margin-top: 15px;
        cursor: pointer;
        width: 23px;
        height: 23px;
    }
}

.attentionAlert {
    &.swal2-container {
        text-align: left;

        .swal2-popup {
            width: 1024px;
            max-width: inherit;
            @media screen and (max-width: $padLandscape) {
                width: 95%;
            }
        }

        .swal2-html-container {
            margin:1em;
            @media screen and (max-width: $padLandscape) {
                margin: 3%;
            }
            @media screen and (max-width: $small) {
                margin: 10px !important;
            }
        }

        .swal2-title {
            padding: 0.8em 0 !important;
        }
    }

    .noticeCon {
        max-height: calc(80vh - 60px);
        padding: 0 20px;
        box-sizing: border-box;
        font-family: 'Noto Sans TC', '微軟正黑體', sans-serif;
        .title2{font-size:18px;}
        div:where(.swal2-container) div:where(.swal2-popup){
            padding:0;
        }

        @media screen and (max-width: $small) {
            padding: 10px;
            font-size: 16px;
        }


        ul {
            list-style-type: decimal;
            list-style-position: outside;
            line-height: 40px;
            padding: 0 20px 0;
            box-sizing: border-box;
            margin: 0 0 20px;
            text-align: left;
            &.caption{padding:0 !important;}
            @media screen and (max-width: $pad) {
                line-height: 30px;
            }


            .blue {
                color: $blue-700;
                font-weight: 700;
            }
        }

        .blueBg {
            margin-bottom: 10px;
            background: $blue-700;
            border-radius: 50px;
            color: #fff;

            .container {
                width: 100%;
                padding:0;
                p {
                    margin: 0
                }
            }

            .yellow {
                color: $popupYellow;
                font-size: 18px;
            }

            @media screen and (max-width: $small) {
                font-size: 16px;
                .yellow {
                    font-size: 14px;
                }
            }
        }

        .space {
            height: 100px;
        }
        .compareTable {
            margin: 0 0 10px;

            ul {
                padding: 0;
                list-style-type: none;
                vertical-align: top;
            }

            li {
                width: 25%;
                display: inline-block;
                height: 100px;
                color: $textColor;
                box-sizing: border-box;
                vertical-align: top;
                border-bottom: 1px solid $blue-700;
                padding: 25px 0;
                text-align: center;

                &:last-of-type, &:nth-last-child(2) {
                    border: 0
                }

                p {
                    margin: 0 10px;
                    @media screen and (max-width: $small) {
                        margin: 0 5px;
                    }
                }

                @media screen and (max-width: $pad) {
                    padding: 15px 0;
                }
                @media screen and (max-width: $small) {
                    width: 50%;
                    height: auto;
                    border: 0;
                    font-size: 16px;
                }
            }

            .compareTop {
                background: $lightBlue;
                border: 2px solid $blue-700;
                border-radius: 50px;
                padding: 10px 0;
                font-size: 20px;
                margin: 10px 0 10px;
                text-align: center;
                color: $blue-700;
                @media screen and (max-width: $pad) {
                    font-size: 18px;
                    margin: 10px 0;
                }
                @media screen and (max-width: $small) {
                    font-size: 16px;
                    padding: 10px
                }
            }

            .title {
                background: $blue-700;
                color: #fff;
                font-size: 16px;
                text-align: center;
                box-sizing: border-box;
                font-weight: 400;

                .yellow {
                    color: $popupYellow;
                    font-size: 16px;
                }

                @media screen and (max-width: $pad) {
                    padding: 15px;
                }
                @media screen and (max-width: $small) {
                    width: 100%;
                    justify-content: center;
                    height: auto;
                    padding: 10px 0;
                }
            }

            .compareMiddle {
                border: 2px solid $blue-700;
                border-radius: $radius;
                box-sizing: border-box;
                overflow: hidden;
                background: #fff;
                @media screen and (max-width: $padLandscape) {
                    display: none;
                }
            }

            .mutiple {
                line-height: 25px;
                border-bottom: 0;
            }

            .css_table {
                display: none;
                border: 0;
                margin: 0 0 20px;
                overflow: inherit;
                border-radius: 0;

                .css_tr:last-of-type {
                    .css_td {
                        &:first-of-type {
                            border-bottom-left-radius: 10px;
                            border-bottom: 2px solid $blue-700;
                        }

                        &:last-of-type {
                            border-bottom-right-radius: 10px;
                            border-bottom: 2px solid $blue-700;
                        }
                    }
                }

                .yellow {
                    color: $popupYellow
                }

                .importTitle {
                    .css_td {
                        color: #fff;
                        font-weight: 500;
                        border: 0;

                        &:first-of-type {
                            border-top-left-radius: 10px;
                        }

                        &:last-of-type {
                            border-top-right-radius: 10px;
                        }
                    }
                }

                .css_td {
                    width: 50%;
                    border: 1px solid $blue-700;
                    vertical-align: middle;
                    border-top: 0;

                    &:first-of-type {
                        border-right: 0;
                        border-left: 2px solid $blue-700;
                    }

                    &:last-of-type {
                        border-right: 2px solid $blue-700;
                    }

                    @media screen and (max-width: $small) {
                        line-height: 25px;
                        font-size: 3vw;
                    }
                }

                @media screen and (max-width: $padLandscape) {
                    display: table;
                }
            }
        }
    }
    .caption{
        border:1px solid $blue-700;
        font-size:16px;
        border-radius: 20px;
        overflow:hidden;
        li{
            display:flex;
            align-items: center;
            border-bottom:1px solid $gray-400;
            &:last-of-type{border:0}
            &.captionTitle{
                background: $blue-700;
                color:#fff;
            }
            p{
                width:50%;
                margin:5px 0;
                box-sizing: border-box;
                padding:0 10px;
                text-align:center;
            }
        }

    }
}
.attention.noticeCon {
    text-align: left;
    li{
        line-height: 42px;
    }
    & ul{
        list-style-type: disc;
        margin-bottom: 0;
    }
}



</style>